import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { INotFoundBlockData } from './INotFoundBlockData';

export const DynamicNotFoundBlock = dynamic<BlockProps<INotFoundBlockData>>(
    () => import('./NotFoundBlock').then(md => md.NotFoundBlock),
);
